enum ConsentType
{
    Read = 0,
    Write = 1,
    SendProductNotifications = 2,
    PrivacyNoticeAccepted = 3,
    TermsAndConditionsAccepted = 4
}

export default ConsentType;
